module.exports = __webpack_public_path__ + "img/menuboard_teryiaki_alt.bfed59d2.jpg";